import React from "react";

export const SectionLabel = ({ children, light }) => (
  <span className={`text-[11px] tracking-[0.25em] uppercase font-semibold ${light ? "text-[#D4AF37]" : "text-accent"}`}>{children}</span>
);
